import React from "react";
import { PanelState, useAppSelector, PanelStateType, NavigationPath, NavigationPathTypes } from "src/common";
import { MailNavigation, DriveNavigation, AdminNavigation, SettingsNavigation, Feedback, QuickStartMenu } from "./";
import ToggleLeftNav from "./ToggleLeftNavigation.component";
import { RootState } from "src/store/configureStore";

type AllProps = {
  type: NavigationPathTypes;
  active_path?: string;
  handleAction: (state: PanelStateType) => void;
}
const components: Partial<Record<NavigationPathTypes, React.FC<any>>> = {
  MailNavigation,
  DriveNavigation,
  AdminNavigation,
  SettingsNavigation
};

function LeftNavigationComponent(props: AllProps) {
  const { type, active_path, handleAction } = props;
  const current_account = useAppSelector((state: RootState) => state.account.current_account);
  const organization = useAppSelector((state: RootState) => state.account.organization);
  const state = useAppSelector((state: RootState) => state.ui.left_nav_state);

  // Description:  Renders the specific links to the module
  const ComponentLinks = () => {
    const TagName = components[type];
    return (!!TagName) ?
      <TagName handleAction={handleAction} active_path={active_path} current_account={current_account} organization={organization} /> :
      <></>;
  };

  return <div className={`${state === PanelState.off ? " closed" : ""}`}>
    <div className="toggle-box">
      <ToggleLeftNav handleAction={handleAction} />
      <p>
        {current_account?.display_name || "My Account"}
        <small>{!!organization ? organization.org_name : current_account?.user_id}</small>
      </p>
    </div>
    <div className="left-navigation">
      <ComponentLinks />
      <hr />
      {
        (type !== NavigationPath.AdminNavigation) && <Feedback type={type} />
      }
      {
        (state === PanelState.on && type !== NavigationPath.AdminNavigation) &&
        <QuickStartMenu />
      }
    </div>
  </div>;
}

export default React.memo(LeftNavigationComponent);
